import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { sessionStatusGuard } from '@copec-gid/copec-one.backoffice-web-security-authorization-module';
import { BaseComponent } from '@copec-gid/copec-one.backoffice-web-default-theme/left-light';
import { ConfProyecto } from '@copec-gid/gid-arquitectura.utilitarios-base-modulo-a16';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';
import { PageWaitComponent } from './core/inicial-componente/page-wait/page-wait.component';

const routes: Routes = [
  {
    path: 'app',
    component: BaseComponent,
    canActivate: [sessionStatusGuard],
    data: {
      onLogout: () => ConfProyecto.callApiLogout(),
      urlLogout: () => ConfProyecto.urlLogout,
			applicationName: () => ConfProyecto.nombreAplicacion,
			urlPerfil: () => ConfProyecto.pathPerfil,
			userLevels: () => ConfProyecto.user_levels,
			accountData: () => ConfProyecto.account_data,
			userData: () => ConfProyecto.user_data,
    },
    children: [
      {
        path: '',
        redirectTo: 'principal',
        pathMatch: 'full'
      },
      {
        path: 'principal',
        loadChildren: () => import('./views/pages/principal/principal.module').then(m => m.PrincipalModule),
      },
      {
        path: 'reconciliations',
        loadChildren: () =>
          import('@copec-gid/copec-one.backoffice-web-reconciliation-module').then(
            (m) => m.ReconciliationModule )
      },
      {
        path: 'accounts',
        loadChildren: () =>
          import('@copec-gid/copec-one.backoffice-web-account-module').then(
            (m) => m.AccountModule )
      },
      {
        path: 'transactions',
        loadChildren: () =>
          import('@copec-gid/copec-one.backoffice-web-transaction-module').then(
          (m) => m.TransactionModule )
      },
      {
        path: 'payouts',
        loadChildren: () =>
          import('@copec-gid/copec-one.backoffice-web-payout-module').then(
          (m) => m.PayoutModule )
      },
    ]
  },
  { path: 'auth-google', loadChildren: () => import('@copec-gid/copec-one.backoffice-web-security-authentication-module').then(m => m.AuthModule) },
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full'
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    data: {
      'type': 404,
      'title': 'Page Not Found',
      'desc': 'Oopps!! The page you were looking for doesn\'t exist.'
    }
  },
  {
    path: 'wait',
    component: PageWaitComponent
  },
  {
    path: 'error/:type',
    component: ErrorPageComponent
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
